<template>
  <div class="pl-7 pr-10">
      <v-row>
        <v-col class="pl-0">
          <div class="primary1--text headline font-weight-bold">
            MUNICÍPIOS IBGE
          </div>
        </v-col>
      </v-row>
    <FiltroMunicipiosIBGE
      v-model="showFiltro"
      @filtrar-municipios-ibge="filtro => filtrarMunicipioIBGE(filtro)"
      @limpar-municipios-ibge="cleanFiltro()"
    />
    <!--
    <v-row class="pb-5" justify="end" align="end" no-gutters>
      <v-col cols="auto">
        <button-cadu @click="showFiltro = true" text="FILTRAR" />
      </v-col>

      <v-col class="ml-4" cols="auto">
        <icon name="download" :size="20" style="cursor: pointer" tooltip="Exportar"/>
      </v-col>
    </v-row>-->

    <v-row>
      <TabelaMunicipiosIBGE
        :loading="isLoadingMunicipiosIBGE"
        ref="tabelaMunicipiosIBGE"
        :municipios="listMunicipios"
        @paginate="args => paginate(args)"
        @ordena="obj => changeOrdem(obj)"
        @filtro-click="openFiltro()"
        @download-click="download"
      />
    </v-row>

    <error-modal
      v-model="error"
      :errObj="errObj"
    />
    <overlay-loading v-model="loadingOverlay"/>
  </div>
</template>

<script>
/* eslint-disable */

import TabelaMunicipiosIBGE from "./Shared/TabelaMunicipiosIBGE"

import FiltroMunicipiosIBGE from "./Shared/FiltroMunicipiosIBGE"

import ConsultaMunicipios from "@/services/Administracao/ConsultaMunicipios";

export default {
  components: {
    TabelaMunicipiosIBGE,
    FiltroMunicipiosIBGE
  },
  data() {
    return {
      showFiltro: false,
      isLoadingMunicipiosIBGE: true,
      loadingOverlay:false,

      codigo: "",
      municipio: "",
      estadoId: "",

      listMunicipios: null,
      args: '',
      ordenacao: 'nome',
      error: false,
      errObj: {}
    };
  },
  methods: {
    openFiltro(){
      this.showFiltro = true
    },
    async paginate(args) {
      this.isLoadingMunicipiosIBGE = true;
      this.args = args;

      await this.getMunicipios(this.argsLocal);
    },
    async filtrarMunicipioIBGE(filtro) {
      let argsPadrao = this.$refs.tabelaMunicipiosIBGE.paginePadrao()
      this.codigo = filtro.codigo ? filtro.codigo : "";
      this.municipio = filtro.municipio ? filtro.municipio : "";
      this.estadoId = filtro.uf.id ? filtro.uf.id : "";
    
      this.isLoadingMunicipiosIBGE = true;

      await this.getMunicipios(`${argsPadrao}&${this.getArgs()}`);
    },
    async cleanFiltro() {
      this.isLoadingMunicipiosIBGE = true;

      await this.getMunicipios(this.argsLocal);
    },
    async getMunicipios(args) {
      const municipios = new ConsultaMunicipios(localStorage.getItem("tokenBearer"), this.$appConfig.config.API);

      await municipios
        .getMunicipiosConsultados(args)
        .then(res => {
          this.listMunicipios = res;
          this.isLoadingMunicipiosIBGE = false;
        })
        .catch(err => {
          this.error = true
          this.errObj.status = err.response.status
          this.errObj.error = err.response.data.message
          this.isLoadingMunicipiosIBGE = false;
        });
    },
    async changeOrdem(obj) {
      this.ordem = obj.ordem;
      this.isLoadingMunicipiosIBGE = true;

      await this.getMunicipios(this.argsLocal);
    },
    async download () {
      let municipios = new ConsultaMunicipios(
        localStorage.getItem("tokenBearer"),
        this.$appConfig.config.API
      )

      try {
        this.loadingOverlay = true
        let response = await municipios.getExportarMunicipios(this.getArgs())
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'municipios.xlsx')
        document.body.appendChild(link)
        link.click()
        this.loadingOverlay = false
      } catch (err) {
        console.error(err)
      }
    },
    getArgs () {
      let args = this.geradorParams(
          {
              name: 'municipioId',
              value: this.codigo || ''
          },
          {
              name: 'nomeMunicipio',
              value: this.municipio
          },
          {
            name: 'estadoId',
            value: this.estadoId
          },
          {
            name: 'ordenacao',
            value: this.ordenacao
          },
          {
            name: 'direcaoOrdenacao',
            value: this.ordem
          }
      )
      return args
    },
    geradorParams (...params) {
      let str = ''
      for (let p of params) {
          if (p.value) {
              str += `${p.name}=${p.value}&`
          }
      }
      if (params.length > 0) {
          str = str.substring(0, str.length - 1)
      }
      return str
    },
  },
  computed: {
    argsLocal () {
      return `${this.args}&${this.getArgs()}`
    }
  }
};
</script>

<style></style>
